import { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import {
  Button,
  Input,
  SubTitle,
} from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Col, Row, Spinner } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
// import EditBusinessTypeModal from "../../Components/Modals/EditBusinessTypeModal.js";
import _ from "lodash";
import { Controller, useForm } from "react-hook-form";
import { IoIosEye } from "react-icons/io";
import { RiEditFill } from "react-icons/ri";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
import SelectFieldComponent from "../../Components/CustomComponents/SelectFieldComponent.js";
import ToolTip from "../../Components/CustomComponents/ToolTip.js";
import DetailPollModal from "../../Components/Modals/DetailPollModal.js";
import EditPollModal from "../../Components/Modals/EditPollModal.js";
import { useGetCategoryListQuery } from "../../Data/services/filterListApi.js";
import {
  useDeletePollMutation,
  useGetAllPollsQuery,
} from "../../Data/services/pollApi.js";
import {
  getPollStatus,
  getPollType,
  POLL_STATUS,
  POLL_STATUS_LIST,
  POLL_TYPE,
  POLL_TYPE_LIST,
} from "../../Helper/index.js";

const PollManagementScreen = ({ setPage }) => {
  const { control, watch } = useForm({
    defaultValues: {
      type: "",
      status: "",
      category_id: "",
    },
  });

  const status = watch("status");
  const type = watch("type");
  const category_id = watch("category_id");

  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");
  const [categoryList, setCategoryList] = useState([]);

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllPollsQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
        type: 20,

        ...(status && status === "all"
          ? { status: "" }
          : { status: status === undefined ? "" : status }),

        // ...(type && type === "all"
        //   ? { type: "" }
        //   : { type: type === undefined ? "" : type }),

        ...(category_id && category_id === "all"
          ? { category_id: "" }
          : { category_id: category_id === undefined ? "" : category_id }),
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);

      if (data.data.length === 0) {
        setIndicationMessage("Data not available");
      }
    }
  }, [data]);

  const { data: categoryListData, isLoading: categoryLoading } =
    useGetCategoryListQuery(
      {},
      {
        refetchOnMountOrArgChange: true,
        // pollingInterval: 5 * 60 * 1000, // min * sec * msec
      }
    );

  useEffect(() => {
    if (categoryListData) {
      // console.log(categoryListData);
      setCategoryList(categoryListData);
    }
  }, [categoryListData]);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);

    // debouncedSearch(query);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleViewModalOpen = () => {
    setViewModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };
  const handleViewModalClose = () => {
    setViewModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  const [deletePoll, { isLoading: isDeleting }] = useDeletePollMutation();

  const deleteData = async (slug) => {
    try {
      const { data } = await deletePoll(slug);
      // console.log(data);
      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "topic",
      text: "Title",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "250px" },
      formatter: (cellContent, row) => (
        <div className="d-flex align-items-center">
          {row.attachments?.[0]?.media_url && (
            <img
              src={row.attachments[0].media_url}
              alt="poll"
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "8px",
                objectFit: "cover",
                marginRight: "10px",
              }}
            />
          )}
          <span className="fw-bold lc-2">{cellContent}</span>
        </div>
      ),
    },
    {
      dataField: "description",
      text: "Description",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "250px" },
      formatter: (cellContent) => (
        <span className="lc-2 small">
          {cellContent ? cellContent : "No description available"}
        </span>
      ),
    },
    {
      dataField: "category.name",
      text: "Category",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "100px" },
      formatter: (cellContent) => (
        <span className="badge bg-info-subtle text-dark">{cellContent}</span>
      ),
    },
    {
      dataField: "owner",
      text: "Created By",
      headerAlign: "center",
      align: "left",
      headerStyle: { width: "250px" },
      formatter: (cellContent, row) => (
        <div className="d-flex align-items-center justify-content-center">
          <img
            src={row.owner?.image_url}
            alt="owner"
            style={{
              width: "35px",
              height: "35px",
              borderRadius: "50%",
              marginRight: "8px",
            }}
          />
          <span>
            {row.owner?.firstname || row.owner?.lastname
              ? `${row.owner.firstname ?? ""} ${row.owner.lastname ?? ""}`
              : row.owner?.user_type}
          </span>
        </div>
      ),
    },
    {
      dataField: "total_likes",
      text: "Engagement",
      headerAlign: "center",
      align: "left",
      headerStyle: { width: "130px" },
      formatter: (cellContent, row) => (
        <div className="d-flex flex-column  gap-2">
          <span className="fw-semibold">💬 {row.total_comments}</span>
          <span className="text-success">👍 {row.total_likes}</span>
          <span className="text-danger">👎 {row.total_dislikes}</span>
        </div>
      ),
    },
    // {
    //   dataField: "type",
    //   text: "Type",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: { width: "120px" },
    //   formatter: (cellContent) => {
    //     const label = getPollType(cellContent);
    //     let badgeClass = "bg-secondary";
    //     if (cellContent === POLL_TYPE.ADMIN_CREATED) badgeClass = "bg-success";
    //     if (cellContent === POLL_TYPE.SUGGESTION) badgeClass = "bg-secondary";
    //     return <span className={`badge ${badgeClass}`}>{label}</span>;
    //   },
    // },
    {
      dataField: "status",
      text: "Status",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "120px" },
      formatter: (cellContent) => {
        const label = getPollStatus(cellContent);

        let badgeClass = "bg-secondary";
        if (cellContent === POLL_STATUS.UPCOMING) badgeClass = "bg-warning"; // UPCOMING
        if (cellContent === POLL_STATUS.ONGOING) badgeClass = "bg-success"; // ONGOING
        if (cellContent === POLL_STATUS.EXPIRED) badgeClass = "bg-danger"; // EXPIRED
        if (cellContent === POLL_STATUS.CANCELLED) badgeClass = "bg-dark"; // CANCELLED

        return <span className={`badge ${badgeClass}`}>{label}</span>;
      },
    },
    {
      dataField: "start_at",
      text: "Duration",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "250px" },
      formatter: (cellContent, row) => {
        const start = row.start_at
          ? new Date(row.start_at).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })
          : null;

        const end = row.end_at
          ? new Date(row.end_at).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })
          : null;

        if (!start || !end) {
          return (
            <span className="badge bg-warning text-dark px-2 py-1">
              No Duration Set
            </span>
          );
        }

        return (
          <div className="d-flex flex-column text-nowrap small">
            <span className="text-success">Start: {start}</span>
            <span className="text-danger">End: {end}</span>
          </div>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "150px" },
      formatter: (cellContent, row) => (
        <div className="d-flex justify-content-center align-items-center ">
          <ToolTip placement="top" content="View">
            <div
              className="d-flex justify-content-center align-items-center bg-primary-hover rounded-3 p-2 mx-2"
              role="button"
              onClick={() => {
                setEditedData(row);
                handleViewModalOpen(true);
              }}
            >
              <IoIosEye />
            </div>
          </ToolTip>
          <ToolTip placement="top" content="Edit">
            <div
              className="d-flex justify-content-center align-items-center bg-primary-hover rounded-3 p-2 mx-2"
              role="button"
              onClick={() => {
                setEditedData(row);
                handleEditModalOpen(true);
              }}
            >
              <RiEditFill />
            </div>
          </ToolTip>
          <ToolTip placement="top" content="Delete">
            <div
              className="d-flex justify-content-center align-items-center bg-danger-hover rounded-3 p-2 mx-2"
              role="button"
              onClick={() => {
                setEditedData(row);
                handleDeleteModalOpen();
              }}
            >
              <MdDeleteForever />
            </div>
          </ToolTip>
        </div>
      ),
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )}

      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <EditPollModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            refetch={refetch}
            categoryList={categoryList.filter(
              (category) => category.label !== "All Category"
            )}
          />
        </Suspense>
      ) : (
        ""
      )}

      {viewModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DetailPollModal
            handleEditModalClose={handleViewModalClose}
            editData={editedData}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div>
          <SubTitle text={"Polls Management"} classes="" />
        </div>

        {
          <Row>
            <Col md={12}>
              <Button
                classes={`${styles.cardBtn} `}
                text="Add More"
                onClick={handleAddUser}
              ></Button>
            </Col>
          </Row>
        }
      </div>

      <div
        className={`${styles.mainTable} ${
          dataFetched && isFetching ? "blur-table" : ""
        }`}
      >
        {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            <div className="d-flex justify-content-end align-items-center gap-2">
              <span style={{ width: "250px" }}>
                <Input
                  type="search"
                  placeholder="Search by name"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </span>

              {/* <Controller
                control={control}
                name="type"
                render={({ field: { onChange, value } }) => (
                  <span style={{ width: "250px" }}>
                    <SelectFieldComponent
                      firstOption={_.isEmpty(value) ? "Select Type" : value}
                      optionsList={[
                        { label: "All", value: "all" },
                        ...POLL_TYPE_LIST,
                      ]}
                      onSelectChange={onChange}
                    />
                  </span>
                )}
              /> */}

              <Controller
                control={control}
                name="status"
                render={({ field: { onChange, value } }) => (
                  <span style={{ width: "250px" }}>
                    <SelectFieldComponent
                      firstOption={_.isEmpty(value) ? "Select Status" : value}
                      optionsList={[
                        { label: "All", value: "all" },
                        ...POLL_STATUS_LIST,
                      ]}
                      onSelectChange={onChange}
                    />
                  </span>
                )}
              />

              <Controller
                control={control}
                name="category_id"
                render={({ field: { onChange, value } }) => (
                  <span style={{ width: "250px" }}>
                    <SelectFieldComponent
                      firstOption={_.isEmpty(value) ? "Select Category" : value}
                      optionsList={categoryList}
                      onSelectChange={onChange}
                    />
                  </span>
                )}
              />
            </div>
            {
              <Table
                classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={rowData || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords} // todo
                totalPages={totalPages} // todo
                pageSize={pageSize} // todo
                currentPage={currentPage} // todo
                setCurrentPage={setCurrentPage} // todo
                setPageSize={setPageSize} // todo
                refetch={refetch} // todo
                // refetch={() => {}} // todo
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default PollManagementScreen;
